/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Cards--packed[_ngcontent-%COMP%]{-moz-column-count:1;column-count:1}.Card-inner[_ngcontent-%COMP%]{padding:0}.Card-50[_ngcontent-%COMP%]{padding-left:.5rem}@media screen and (min-width:960px){.Card-50[_ngcontent-%COMP%]{flex:0 0 49%}}.Card-50[_ngcontent-%COMP%]:first-child{padding-right:.5rem;padding-left:0}legend.Card-title[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start}"];
export { styles as styles };
